import { getReportAuthInfo } from '@/api/independent/reporting'

const state = {
  dragging: false,
  pagesize: 20,
  userKanbanAuth: [], //看板权限
  userIsAdminManager: false,
  userDepartment: [],
  userDepartmentAuth: [], //部门权限
  groupEditObj: {
    show: false,
    id: 0,
    title: '',
    kanban_id: 0,
  },
  articleDetailEditing: false, //文章详情是否处于编辑状态
  reportInfo: {
    viewType: '1', // 汇报查看权限，1-所属部门，2-全公司
    auth: false, // 入口显示
    remindId: '', // 提醒的汇报模板id
    tplList: [], // 模板列表
  },
  emojiList: [], //表情列表
  annotationListNeedRefresh: false, //注解列表需要刷新
  annotationManageModalShow: false, //是否展示注解管理弹窗
  taskLeaderSelectList: [], //任务负责人下拉列表
  ideaKanbanId: 207, //想法池看板id
  reportUnreadCount: {
    // 精选汇报未读统计
    daily: 0, // 日报
    week: 0, // 周报
  },
}

const getters = {
  dragging: (state) => state.dragging,
  pagesize: (state) => state.pagesize,
  groupEditObj: (state) => state.groupEditObj,
  userKanbanAuth: (state) => state.userKanbanAuth,
  userIsAdminManager: (state) => state.userIsAdminManager,
  userDepartment: (state) => state.userDepartment,
  userDepartmentAuth: (state) => state.userDepartmentAuth,
  articleDetailEditing: (state) => state.articleDetailEditing,
  reportInfo: (state) => state.reportInfo,
  emojiList: (state) => state.emojiList,
  annotationListNeedRefresh: (state) => state.annotationListNeedRefresh,
  annotationManageModalShow: (state) => state.annotationManageModalShow,
  taskLeaderSelectList: (state) => state.taskLeaderSelectList,
  ideaKanbanId: (state) => state.ideaKanbanId,
  reportUnreadCount: (state) => state.reportUnreadCount,
}

const mutations = {
  SET_DRAGGING: (state, dragging) => {
    state.dragging = dragging
  },
  SET_GROUP_EDIT_OBJ: (state, groupEditObj) => {
    state.groupEditObj = groupEditObj
  },
  SET_USER_KANBAN_AUTH: (state, userKanbanAuth) => {
    state.userKanbanAuth = userKanbanAuth
  },
  SET_USER_IN_ADMIN_GROUP: (state, userIsAdminManager) => {
    state.userIsAdminManager = userIsAdminManager
  },
  SET_USER_DEPARTMENT: (state, userDepartment) => {
    state.userDepartment = userDepartment
  },
  SET_USER_DEPARTMENT_AUTH: (state, userDepartmentAuth) => {
    state.userDepartmentAuth = userDepartmentAuth
  },
  SET_ARTICLE_DETAIL_EDITING: (state, articleDetailEditing) => {
    state.articleDetailEditing = articleDetailEditing
  },
  SET_REPORT_INFO: (state, { auth, remindId, viewType, tplList, thinkingRemindDay }) => {
    state.reportInfo.auth = auth
    state.reportInfo.remindId = remindId
    state.reportInfo.viewType = viewType
    state.reportInfo.tplList = tplList
    state.reportInfo.thinkingRemindDay = thinkingRemindDay
  },
  SET_EMOJI_LIST: (state, emojiList) => {
    state.emojiList = emojiList
  },
  SET_ANNOTATION_LIST_NEED_REFRESH: (state, annotationListNeedRefresh) => {
    state.annotationListNeedRefresh = annotationListNeedRefresh
  },
  SET_ANNOTATION_MANAGE_MODAL_SHOW: (state, annotationManageModalShow) => {
    state.annotationManageModalShow = annotationManageModalShow
  },
  SET_TASK_LEADER_SELECT_LIST: (state, taskLeaderSelectList) => {
    state.taskLeaderSelectList = taskLeaderSelectList
  },
  SET_UNREAD_COUNT: (state, { daily, week }) => {
    state.reportUnreadCount.daily = daily > 0 ? daily : 0
    state.reportUnreadCount.week = week > 0 ? week : 0
  },
}

const actions = {
  setDragging({ commit }, dragging) {
    commit('SET_DRAGGING', dragging)
  },
  setGroupEditObj({ commit }, groupEditObj) {
    commit('SET_GROUP_EDIT_OBJ', groupEditObj)
  },
  setUserKanbanAuth({ commit }, userKanbanAuth) {
    commit('SET_USER_KANBAN_AUTH', userKanbanAuth)
  },
  setUserIsAdminManager({ commit }, userIsAdminManager) {
    commit('SET_USER_IN_ADMIN_GROUP', userIsAdminManager)
  },
  setUserDepartment({ commit }, userDepartment) {
    commit('SET_USER_DEPARTMENT', userDepartment)
  },
  setUserDepartmentAuth({ commit }, userDepartmentAuth) {
    commit('SET_USER_DEPARTMENT_AUTH', userDepartmentAuth)
  },
  setArticleDetailEditing({ commit }, articleDetailEditing) {
    commit('SET_ARTICLE_DETAIL_EDITING', articleDetailEditing)
  },
  async getReportInfo({ commit }, extraInfo) {
    const update_report_dot = extraInfo ? extraInfo.update_report_dot : false
    let viewType = '1'
    let auth = false
    let remindId = ''
    let tplList = []
    let thinkingRemindDay = 0
    let dailyUnreadCount = 0
    let weekUnreadCount = 0
    const res = await getReportAuthInfo()
    if (res && res.code === 0) {
      auth = res.data.show_icon
      viewType = res.data.view_type
      tplList = res.data.reminder
      dailyUnreadCount = parseInt(res.data.unread_daily_reports_count || 0)
      weekUnreadCount = parseInt(res.data.unread_weekly_reports_count || 0)
      const reminder = res.data.reminder
      reminder.some((v) => {
        if (v.need_remind) {
          remindId = v.report_tpl_id
          return true
        }
      })
      reminder.some((v) => {
        if (v.thinking_reminder > 0) {
          thinkingRemindDay = v.thinking_reminder
          return true
        }
      })
    }
    if (!update_report_dot) {
      // 仅更新汇报红点时，不更新report_info
      commit('SET_REPORT_INFO', { auth, remindId, viewType, tplList, thinkingRemindDay })
    }
    commit('SET_UNREAD_COUNT', { daily: dailyUnreadCount, week: weekUnreadCount })
  },
  setEmojiList({ commit }, emojiList) {
    commit('SET_EMOJI_LIST', emojiList)
  },
  setAnnotationListNeedRefresh({ commit }, annotationListNeedRefresh) {
    commit('SET_ANNOTATION_LIST_NEED_REFRESH', annotationListNeedRefresh)
  },
  setAnnotationManageModalShow({ commit }, annotationManageModalShow) {
    commit('SET_ANNOTATION_MANAGE_MODAL_SHOW', annotationManageModalShow)
  },
  setTaskLeaderSelectList({ commit }, taskLeaderSelectList) {
    commit('SET_TASK_LEADER_SELECT_LIST', taskLeaderSelectList)
  },
  setUnreadCount({ commit }, { daily, week }) {
    commit('SET_UNREAD_COUNT', { daily, week })
  },
}

export default { state, getters, mutations, actions }
